"use client";

import React from "react";

export interface GqWebScreenshotBlockProps {
    label?: string;
    sublabel?: string;
    url?: string;
    imageSrc?: string;
    imageAlt?: string;
}

export default function GqWebScreenshotBlock({
    label = "Desktop Viewport [1280px]",
    sublabel = "Actual Website Screenshot",
    url = "https://guestiqo.uk",
    imageSrc = "/images/guestiqo_website_screenshot.png",
    imageAlt = "Guestiqo Marketing Website Screenshot"
}: GqWebScreenshotBlockProps) {
    return (
        <section className="py-28 px-6 md:px-12 lg:px-24 bg-[#FDFBF8] border-b border-[#EDE6DD] text-[#444] font-sans antialiased w-full">
            <div className="container mx-auto">
                <div className="mb-6 flex justify-between items-center max-w-5xl mx-auto">
                    {label && (
                        <span className="text-[11px] font-mono text-zinc-500 tracking-wider">
                            {label.includes("[") ? (
                                <>{label.split("[")[0]}<span className="text-[#D4A574] font-semibold">[{label.split("[")[1]}</span></>
                            ) : label}
                        </span>
                    )}
                    {sublabel && <span className="text-[10px] font-mono text-zinc-400">{sublabel}</span>}
                </div>
                <div className="w-full max-w-5xl mx-auto rounded-2xl overflow-hidden border border-[#EDE6DD] bg-white p-2 shadow-[0_30px_70px_rgba(0,0,0,0.08)]">
                    <div className="w-full h-10 bg-zinc-50 border-b border-[#EDE6DD] rounded-t-xl flex items-center px-4 justify-between">
                        <div className="flex gap-1.5 items-center">
                            <div className="w-3 h-3 rounded-full bg-red-500/80" />
                            <div className="w-3 h-3 rounded-full bg-yellow-500/80" />
                            <div className="w-3 h-3 rounded-full bg-green-500/80" />
                        </div>
                        {url && (
                            <div className="h-6 bg-white px-12 rounded-md text-[10px] font-mono text-zinc-500 flex items-center border border-[#EDE6DD] gap-2 select-none">
                                <span className="text-zinc-300">{url.startsWith("https://") ? "https://" : ""}</span>
                                {url.replace("https://", "").replace("http://", "")}
                            </div>
                        )}
                        <div className="w-16" />
                    </div>
                    {imageSrc && (
                        <div className="relative w-full bg-[#FDFBF8]">
                            <img src={imageSrc} alt={imageAlt || "Screenshot"} className="w-full h-auto block rounded-b-xl" loading="lazy" />
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}
